import React from "react";

export function Alert({ children, className = "", ...props }) {
  return (
    <div data-slot="alert" role="alert" className={`coss-alert-ui ${className}`} {...props}>
      {children}
    </div>
  );
}

export function AlertTitle({ children, className = "", ...props }) {
  return (
    <div data-slot="alert-title" className={`coss-alert-ui__title ${className}`} {...props}>
      {children}
    </div>
  );
}

export function AlertDescription({ children, className = "", ...props }) {
  return (
    <div data-slot="alert-description" className={`coss-alert-ui__description ${className}`} {...props}>
      {children}
    </div>
  );
}
